import _ from "lodash";
import PropTypes from "prop-types";
import { forwardRef, useId } from "react";
import { Field, useFormState } from "react-final-form";
import RegularSelect from "react-select";
import AsyncSelect from "react-select/async";
import CreatableSelect from "react-select/creatable";
import { Label } from "reactstrap";

const SelectField = (props) => {
  const generatedId = useId();
  const id = props.id ?? generatedId;

  const validate = (value) => {
    value = value || props.value;
    const isValueEmpty = _.every(value, _.isEmpty);

    if (props.required) {
      if (!value) {
        return "Kötelező mező!";
      }

      if (typeof value === "object") {
        if (isValueEmpty) {
          return "Kötelező mező!";
        }
      }
    }
  };

  return (
    <Field
      validate={validate}
      id={id}
      name={id}
      // Erre a propra azért van szükség, hogy a props.value feltöltésével megváltozzon a Field propja is, és ez a validációt újramegfuttatja
      // Erre azért van szükség, mert különben a betöltött Form azonnali submit-ja elbukna, mivel a legelső (és akkor egyetlen) validáció a betöltéskor van, amikor még üres a value
      data={props.value ? '' : undefined}
      value={props.value}
      onChange={props.onChange}
    >
      {(currentProps) => (
        <ReactSelectAdapter
          {...currentProps.input}
          {...props}
          onChange={(e) => {
            currentProps?.input?.onChange?.(e);
            currentProps?.onChange?.(e);
          }}
        />
      )}
    </Field>
  );
};

const ReactSelectAdapter = forwardRef(
  (
    {
      label,
      tooltip,
      required,
      styles,
      value,
      id,
      variant = "regular",
      labelComponent: LabelComponent = "span",
      onChange,
      onInputChange,
      ...rest
    },
    ref
  ) => {
    const { errors, touched } = useFormState();
    const error = errors && id in errors ? errors[id] : null;
    const shouldDisplayError = touched[id] && !!error;

    const Component =
      variant === "async"
        ? AsyncSelect
        : variant === "creatable"
        ? CreatableSelect
        : RegularSelect;

    return (
      <div style={{ width: "100%" }}>
        {label && (
          <Label for={id} className={shouldDisplayError && "text-danger"}>
            <div className="row no-gutters justify-content-between">
              <div className="col-auto">
                <LabelComponent>{label}</LabelComponent> {required && " *"}{tooltip}
              </div>
              {shouldDisplayError && error}
            </div>
          </Label>
        )}

        <Component
          id={id}
          styles={{
            ...styles,
            control: (base) => ({
              ...base,
              ...styles?.control,
              border: `1px solid ${
                shouldDisplayError ? "red" : "lightgrey"
              } !important`,
              boxShadow: "none",
              borderRadius: "0",
            }),
          }}
          ref={ref}
          value={value}
          onInputChange={onInputChange}
          onChange={onChange}
          {...rest}
        />
      </div>
    );
  }
);

SelectField.propTypes = {
  variant: PropTypes.oneOf(["regular", "async", "creatable"]),
  labelComponent: PropTypes.elementType,
};

export default SelectField;
